var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/SeatRequestModal/NotAvailableModalContent.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@wds/modal';
import { Button } from '@wds/button';
import { T } from '@sm/intl';
import COPY from './SeatRequestCopy';
var NotAvailableModalContent = function NotAvailableModalContent(_ref) {
  var onModalFinished = _ref.onModalFinished,
    team = _ref.team;
  var _team$accountOwner = team.accountOwner,
    _email = _team$accountOwner.email,
    firstName = _team$accountOwner.firstName,
    lastName = _team$accountOwner.lastName;
  var emailLabel = firstName ? "".concat(firstName).concat(lastName ? "\xA0".concat(lastName) : '') : _email;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Header, {
    header: /*#__PURE__*/React.createElement(T, {
      desc: COPY.MODAL_TITLE_NOT_AVAILABLE,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 15,
        columnNumber: 29
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.NOT_AVAILABLE_DESC_1,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.NOT_AVAILABLE_DESC_2,
    values: {
      email: function email() {
        return /*#__PURE__*/React.createElement("a", {
          href: "mailto:".concat(_email),
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 24,
            columnNumber: 28
          }
        }, emailLabel);
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Modal.Footer, {
    align: "right",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onModalFinished,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CLOSE_BUTTON,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 11
    }
  }))));
};
NotAvailableModalContent.propTypes = {
  onModalFinished: PropTypes.func.isRequired,
  team: PropTypes.shape({
    accountOwner: PropTypes.shape({
      email: PropTypes.string.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string
    }).isRequired
  }).isRequired
};
export default NotAvailableModalContent;
//# sourceMappingURL=NotAvailableModalContent.js.map